/* @flow */
// $FlowIgnore
import _ from 'lodash';
// $FlowIgnore
import { connect } from 'react-redux';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Authorization extends Component {
  static propTypes = {
    projectRoles: PropTypes.object,
    permissions: PropTypes.array,
    predicate: PropTypes.func,
    children: PropTypes.any
  };

  render(): React.Element {
    let {projectRoles, permissions, predicate, children} = this.props;
    let elements = _.isArray(children) ? children : [children];
    let pred = predicate || (() => true);
    let index = pred(projectRoles) ? 0 : 1;

    return elements[ index ] || null;
  }
}

export default connect(
  ({
    auth: {
      user: {
        projects: {
          gdc_ids: projectRoles
        }
      }
    }
  }) => ({ projectRoles })
)(Authorization);
